
import { Table, TableBody, TableCell, TableHeader, TableHead, TableRow } from "@/components/ui/table";
import { PuttSituation } from "@/types/golf";
import { useTranslation } from "react-i18next";

interface PuttingScoreTableProps {
  situation: PuttSituation;
  scores: Record<string, number[]>;
  getPointTotal: (point: string) => number;
  totalPoints: number;
  currentIndex: number;
  maxAttempts: number;
}

const PuttingScoreTable = ({ 
  situation, 
  scores, 
  getPointTotal, 
  totalPoints, 
  currentIndex,
  maxAttempts
}: PuttingScoreTableProps) => {
  const { t } = useTranslation('training');
  
  return (
    <div className="space-y-4 md:space-y-8 overflow-x-auto">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="text-xs md:text-sm">{t('putting.point')}</TableHead>
            <TableHead className="text-xs md:text-sm">{t('putting.distance')}</TableHead>
            {Array.from({ length: maxAttempts }, (_, i) => (
              <TableHead key={i} className="text-xs md:text-sm">
                {t(`putting.attempt${i + 1}`, { defaultValue: `Essai ${i + 1}` })}
              </TableHead>
            ))}
            <TableHead className="text-xs md:text-sm">{t('putting.total')}</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {situation.distances.map((distance) => (
            <TableRow key={distance.point}>
              <TableCell className="text-xs md:text-sm">{distance.point}</TableCell>
              <TableCell className="text-xs md:text-sm">{distance.distance}m</TableCell>
              {Array.from({ length: maxAttempts }, (_, i) => (
                <TableCell key={i} className="text-xs md:text-sm">
                  {scores[distance.point]?.[i] ?? "-"}
                </TableCell>
              ))}
              <TableCell className="text-xs md:text-sm">{getPointTotal(distance.point)}</TableCell>
            </TableRow>
          ))}
          <TableRow className="font-bold">
            <TableCell colSpan={maxAttempts + 2} className="text-xs md:text-sm">{t('putting.totalPoints')}</TableCell>
            <TableCell className="text-xs md:text-sm">{totalPoints}</TableCell>
          </TableRow>
          <TableRow className="font-bold">
            <TableCell colSpan={maxAttempts + 2} className="text-xs md:text-sm">{t('putting.index')}</TableCell>
            <TableCell className="text-xs md:text-sm">{currentIndex}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </div>
  );
};

export default PuttingScoreTable;
